<template lang="pug">
  #footer
    //- a#knowmore(:href="'/' + $LOCALE + '/sara'")
    ul.navigations
      li
        ul
          li.title {{ $LANG.nav.COL1_T1 }}
          li
            a(:href="'/' + $LOCALE + '/about/story-of-smaland'") {{ $LANG.nav.COL1_D1 }}
          li
            a(:href="'/' + $LOCALE + '/about/angna-and-anya'") {{ $LANG.nav.COL1_D2 }}
          li
            a(:href="'/' + $LOCALE + '/about/how-to-join'") {{ $LANG.nav.COL1_D3 }}
          li
            a(:href="'/' + $LOCALE + '/benefits-of-smales'") {{ $LANG.nav.COL1_D4 }}
          li
            a(:href="'/' + $LOCALE + '/about/benefits-of-smales'") {{ $LANG.nav.COL1_D5 }}

      li
        ul
          li.title {{ $LANG.nav.COL2_T1 }}
          li
            a(:href="'/' + $LOCALE + '/fun-things-at-home/bug-news'") {{ $LANG.nav.COL2_D1 }}
          li
            a(:href="'/' + $LOCALE + '/fun-things-at-home/fun-ideas'") {{ $LANG.nav.COL2_D2 }}
          li
            a(:href="'/' + $LOCALE + '/fun-things-at-home/swedishness'") {{ $LANG.nav.COL2_D3 }}

      li
        ul
          li.title {{ $LANG.nav.COL3_T1 }}
          li
            a(:href="'/' + $LOCALE + '/activities-promotions/upcoming-activities'") {{ $LANG.nav.COL3_D1 }}
          li
            a(:href="'/' + $LOCALE + '/activities-promotions/partner-promotions'") {{ $LANG.nav.COL3_D2 }}
          li
            a(:href="'/' + $LOCALE + '/activities-promotions/contest-winners'") {{ $LANG.nav.COL3_D2 }}

      li
        ul
          li.title {{ $LANG.nav.COL4_T1 }}
          li
            a(:href="'/' + $LOCALE + '/shroom-store/food-menu'") {{ $LANG.nav.COL4_D1 }}
          li
            a(:href="'/' + $LOCALE + '/shroom-store/merchandise'") {{ $LANG.nav.COL4_D2 }}
          li
            a(:href="'/' + $LOCALE + '/shroom-store/how-to-use-shroom'") {{ $LANG.nav.COL4_D3 }}
          li
            a(:href="'/' + $LOCALE + '/shroom-store/how-to-earn-smallish-dallars'") {{ $LANG.nav.COL4_D4 }}

    .copyright
      p &copy; Inter IKEA Systems B.V. 2007, 2011
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      lang: 'en'
    }
  },
  // router,
  mounted () {
    // document.querySelector('#app-container').classList.add('active')

    const currentUrl = window.location.href
    if (currentUrl.indexOf('/th/') >= 0) {
      this.lang = 'th'
    }
  },
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // },
  methods: {
    changeLocale (lang) {
      const currentUrl = window.location.href
      const splittedPath = currentUrl.split('/')
      // staging/production lang config
      // if (splittedPath[5] !== lang) {
      // local lang config
      // if (splittedPath[4] !== lang) {
      if (splittedPath[5] !== lang) {
        const remUrlPos = currentUrl.indexOf(this.lang)
        const remUrl = currentUrl.substr(remUrlPos + 2)
        const startUrl = currentUrl.substr(0, remUrlPos)
        window.location = startUrl + lang + remUrl
      }
    },

    redirect (url) {
      const currUrl = window.location.href.split('/')
      let baseURL = currUrl[2]
      const newLoc = 'https://' + baseURL + '/' + this.lang + '/' + url
      window.location = newLoc
    }
  }
}
</script>
<style lang="sass" scoped>
@import "../sass/variables"

#footer
  // position: absolute
  // bottom: 0
  width: 100%
  padding-top: 340px
  background-image: url("../assets/images/footer_party-th.png")
  background-position: top
  // background-color: #cadc2a
  background-repeat: repeat-x
  background-size: cover
  +desktop
    z-index: 1
  +mobile
    z-index: -1
  +clearfix
  +mobile
    background-image: url("../assets/images/footer-m-th.png")
    background-position: bottom
    // background-color: #cadc2a
    background-repeat: no-repeat
    background-size: 100%

  a#knowmore
    display: block
    float: right
    width: 245px
    height: 88px
    // right: 5%
    // bottom: 85%
    margin-right: 5%
    background-image: url("../assets/images/alex-tampi_bottom.png")
    &:hover
      background-image: url("../assets/images/alex-tampi_bottom-on.png")

  > ul.navigations
    +clearlist
    float: left
    width: 100%
    display: flex
    flex-flow: row wrap
    justify-content: center
    font-size: 11px
    color: #727f0f
    padding-bottom: 30px
    @media #{$mobile}
      display: none

    > li
      & + li
        margin-left: 30px
        padding-left: 10px
        border-left: 1px solid #727f0f

      a
        cursor: pointer
        color: #727f0f
        text-decoration: none

        &:hover
          text-decoration: underline

      .title
        color: #727f0f
        font-weight: bold

      ul
        +clearlist

        li + li
          margin-top: 5px

  > .copyright
    text-align: center
    font-size: 10px
    float: left
    width: 100%
    color: $grey

    a
      color: inherit

a
  color: #0099CC

</style>